import script from "./CreatorRevenueChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorRevenueChart.vue?vue&type=script&setup=true&lang=js"

import "./CreatorRevenueChart.vue?vue&type=style&index=0&id=074b9344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074b9344"]])

export default __exports__